import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { type RawAction } from "@opstel/query/v2/opstelClient";
import { actionSchema } from "@opstel/query/v2/actionParser";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { Action } from "@opstel/query/v2/models/action";

// Extracted as separate function to keep reference stable over renders
function parseAction(rawAction: RawAction): Action {
  const result = actionSchema.safeParse(rawAction);
  if (!result.success) {
    console.error(result.error);
    throw result.error;
  }
  return result.data;
}

export function useActionQuery({ actionId }: { actionId: string }): UseQueryResult<Action> {
  const { instanceId } = useCurrentInstanceId();
  const { opstelClient } = useOpstelClient();

  return useQuery({
    queryKey: instances.current(instanceId).action(actionId).everything,
    queryFn: () => opstelClient.getAction({ instanceId: instanceId ?? "", actionId }),
    select: parseAction,
    staleTime: Infinity,
  });
}
